export const JWT_TOKEN_KEY = "jwt_token";

export const REFRESH_TOKEN_KEY = "refresh_token";

export const DEVICE_ID_KEY = "device_id";

export const USER_DATA_KEY = "user_data";
